module.exports = __webpack_public_path__ + "assets/pebbles-footer.d58194c7.svg";